import ConfirmationDialog from 'components/Common/ConfirmationDialog';
import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Stack, Typography } from '@mui/material';
import { useFetchCleanRoomQuestionCountByQuestionId } from 'hooks/questionAPIs';


const LoadingSkeleton = () => Array.from({ length: 6 },
  (_, i) => <Skeleton variant='rectangular' key={i} height={24} sx={{ mb: 2 }} />);

const dialogMessage = (isLoadingCount, isErrorCount, cleanRoomQuestionCount, questionDisplayID) => {
  if (isLoadingCount) {
    return <LoadingSkeleton />;
  }
  if (isErrorCount) {
    return <Typography>Error loading CRQ count.</Typography>;
  }
  return (
    <>
      <Typography fontWeight={500}>
        Question Display ID:
        {' '}
        <Typography component='span' fontWeight={700}>{questionDisplayID}</Typography>
      </Typography>
      <br />
      {cleanRoomQuestionCount > 1 && (
        <Typography fontWeight={500}>
          This action will impact
          {' '}
          {cleanRoomQuestionCount - 1}
          {' '}
          more CRQ(s).
        </Typography>
      )}
      <br />
      <Typography fontWeight={500}>
        Are you sure you want to unpublish the question?
      </Typography>
      <Typography fontWeight={700}>
        This could affect syncing to HI and run retention
      </Typography>
    </>
  );
};

const UnpublishQuestionDialog = ({
  openUnpublishDialog,
  setOpenUnpublishDialog,
  questionId,
  questionDisplayID,
  handleUnpublish,
}) => {
  const {
    data: cleanRoomQuestionCount = 0,
    isLoading: isLoadingCount,
    isError: isErrorCount,
  } = useFetchCleanRoomQuestionCountByQuestionId(
    questionId, openUnpublishDialog,
  );

  return (
    <ConfirmationDialog
      open={openUnpublishDialog}
      title={(
        <Stack display='flex' flexDirection='row' alignItems='center' gap={1}>
          <WarningAmberRoundedIcon
            fontSize='large'
            sx={theme => ({ color: theme.palette.warning.main })}
          />
          <Typography variant='h3' fontWeight='bolder'>
            Confirm Unpublish
          </Typography>
        </Stack>
      )}
      loading={isLoadingCount}
      message={(
        dialogMessage(isLoadingCount, isErrorCount, cleanRoomQuestionCount, questionDisplayID)
      )}
      onConfirm={() => {
        handleUnpublish(questionId);
        setOpenUnpublishDialog(false);
      }}
      onCancel={() => setOpenUnpublishDialog(false)}
    />
  );
};

export default UnpublishQuestionDialog;

